import ShipmentDetails from './components/form/steps/ShipmentDetails';
import CustomerSelect from './components/form/steps/Customer';
import Shipment from './components/form/steps/Shipment';
import Template from './components/form/steps/Template';
import Form from './components/form/steps/Form';
import BulkSubmission from './components/form/steps/BulkSubmission';
import { NewShipmentFormFields, Steps } from './types';
import {
    shipmentSchema,
    formSchema,
    customerSchema,
    templateSchema,
    shipmentDetailsSchema,
    bulkSubmissionSchema,
} from './validationSchemas';
import { StepConfig } from 'components/new-ui/composed/multistep-form/types';

export const stepsConfig: StepConfig<NewShipmentFormFields>[] = [
    {
        disabled: true,
        key: Steps.SHIPMENT,
        label: 'Shipment',
        validationSchema: shipmentSchema,
        component: Shipment,
    },
    {
        disabled: true,
        key: Steps.FORM,
        label: 'Form',
        validationSchema: formSchema,
        component: Form,
    },
    {
        key: Steps.CUSTOMER,
        label: 'Customer',
        validationSchema: customerSchema,
        component: CustomerSelect,
    },
    {
        key: Steps.TEMPLATE,
        label: 'Template',
        validationSchema: templateSchema,
        component: Template,
    },
    {
        key: Steps.SHIPMENT_DETAILS,
        label: 'Shipment Details',
        validationSchema: shipmentDetailsSchema,
        component: ShipmentDetails,
    },
    {
        key: Steps.BULK_SUBMISSION,
        label: 'Bulk Submission',
        validationSchema: bulkSubmissionSchema,
        component: BulkSubmission,
    },
];
